import React from "react"
import PropTypes from "prop-types"
import { Route, Redirect } from "react-router-dom"
import PagePlaceholder from "components/Common/PagePlaceholder"

const Authmiddleware = ({
  component: Component,
  layout: Layout,
  isAuthProtected,
  ...rest
}) => {
  // Check if authentication is required and user is not authenticated
  if (isAuthProtected && !localStorage.getItem("authUser")) {
    return (
      <Redirect to={{ pathname: "/login", state: { from: rest.location } }} />
    )
  }

  // Render the component within the specified layout
  return (
    <Route
      {...rest}
      render={props => (
        <Layout>
         {isAuthProtected ? <PagePlaceholder><Component {...props} /></PagePlaceholder>  :  <Component {...props} />} 
        </Layout>
      )}
    />
  )
}

Authmiddleware.propTypes = {
  isAuthProtected: PropTypes.bool,
  component: PropTypes.any,
  location: PropTypes.object,
  layout: PropTypes.any,
}

export default Authmiddleware
